export default __webpack_public_path__ + "static/media/image.j-tech.d6ad6885.png";